export default __webpack_public_path__ + "static/arrow-green-down-18367e7aeb31e0b7519a1bc4c463eeec.png";